let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3xec3"), load("c6Kww"), load("4sZyu")]).then(() => parcelRequire('3iK0z'));